import formatIntegerBySpace from '../../../../helpers/formatters/format-integer-by-space'
import outputCalculatedValue from '../../../../helpers/formatters/output-calculated-value'
import ShipmentToolingCostCell from '../../components/cells/tooling-cost/tooling-cost'
import { renderShipmentCalculated } from '../../helpers/render-shipment-calculated'
import type { ShipmentColumn } from '../../types/column-types'

export const consumablesGroupColumn: ShipmentColumn = {
    key: 'consumablesGroup',
    dataIndex: ['calculated', 'consumables'],
    title: 'Стоимость расходников и оборудования',
    // @ts-ignore
    children: [
        {
            key: 'paintCost',
            dataIndex: ['calculated', 'paintCost'],
            title: 'Краска',
            width: 80,
            render: renderShipmentCalculated(calculated =>
                formatIntegerBySpace(Math.round((calculated?.paintCost || 0) * 10) / 10)
            ),
        },
        {
            key: 'materialCost',
            dataIndex: ['calculated', 'materialCost'],
            title: 'Материал',
            width: 80,
            render: renderShipmentCalculated(calculated =>
                formatIntegerBySpace(Math.round((calculated?.materialCost || 0) * 10) / 10)
            ),
        },
        {
            key: 'stampCost',
            dataIndex: ['calculated', 'stampCost'],
            title: 'Штамп',
            width: 120,
            render: renderShipmentCalculated((calculated, shipment) => (
                <ShipmentToolingCostCell
                    shipment={shipment}
                    kind='stamp'
                    value={outputCalculatedValue(calculated?.stampCost || 0)}
                />
            )),
        },
        {
            key: 'formsCost',
            dataIndex: ['calculated', 'formsCost'],
            title: 'Формы',
            width: 120,
            render: renderShipmentCalculated((calculated, shipment) => (
                <ShipmentToolingCostCell
                    shipment={shipment}
                    kind='forms'
                    value={formatIntegerBySpace(Math.round((calculated?.formsCost || 0) * 10) / 10)}
                />
            )),
        },
    ],
}
